import React from 'react'
import Pokeball from 'components/template/Pokeball'
import { useSelector } from 'react-redux'

const PokeballDarkLight = () => {
    const mode = useSelector((state) => state.theme.mode)

    return <Pokeball mode={mode} />
}

export default PokeballDarkLight